<template>
  <Component
    v-if="curation"
    :is="tag"
    class="jps-curation-span"
  >
    <slot :curation="curation">{{ ls(curation?.title) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
const dataStore = useDataStore()

interface Props {
  id: string
  tag?: string
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})

const curation = computed(() => {
  return dataStore.curation_meta(props.id)
})
</script>
